var __templateData = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"jumbotron\">\r\n  <div class=\"text-center\"><i class=\"fa fa-5x fa-frown-o\" style=\"color:#d9534f;\"></i></div>\r\n  <h1 class=\"text-center\">404 Page non trouvée<p> </p></h1>\r\n  <p class=\"text-center\">"
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "</p>\r\n  <p class=\"text-center\"><a class=\"btn btn-primary\" href=\"#\"><i class=\"fa fa-home\"></i> Retour a l'accueil</a></p>\r\n</div>\r\n";
},"useData":true});
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}